<!-- SAVE (form) -->
@if (hasNeverSavedOrRename) {
<h2 mat-dialog-title>Save Quote: Provide Name</h2>
<mat-dialog-content>
  @if(isDashboardPage === false){
  <p class="center">Note: All saved quotes are available in the producer dashboard</p>
  }
  <form [formGroup]="firstSaveRenameForm">
    <mat-form-field appearance="outline">
      <mat-label>Quote Name</mat-label>
      <input matInput formControlName="quoteName" />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <!-- SAVE -->
   @if (!isLoading) { 
  <button mat-raised-button color="primary" type="button" [disabled]="!firstSaveRenameForm.valid" (click)="doSave(firstSaveRenameForm)">
    Save Quote
  </button>
   } @else {
  <mat-spinner [diameter]="25"></mat-spinner>
  }
</mat-dialog-actions>
} @else {
<h2 mat-dialog-title>Update or Create New Quote</h2>
<mat-dialog-content>
  <p class="center">Note: All saved quotes are available in the producer dashboard</p>
  <form [formGroup]="saveQuoteForm" class="margin-topped">

    <!-- UPDATE or CREATE -->
    <div class="actions-container">

      <!-- SAVE -->
      <button mat-raised-button color="primary" type="button" (click)="openSaveQuoteForm()">
        <div class="button-icon-spacer">
          <!-- ICONOGRAPHY -->
          <span [ngClass]="{'hidden': !isUpdateFlow, 'shown': isUpdateFlow }" class="material-symbols-outlined check-icon">check_circle</span>
          <span class="text">Update Existing</span>
          <span [ngClass]="{'hidden': true, 'shown': false }" class="material-symbols-outlined check-icon">check_circle</span>
        </div>
      </button>

      <!-- CREATE -->
      <button mat-raised-button color="primary" type="button" (click)="openCreateQuoteForm()">
        <div class="button-icon-spacer">
          <!-- ICONOGRAPHY -->
          <span [ngClass]="{'hidden': !isCreateFlow, 'shown': isCreateFlow }" class="material-symbols-outlined check-icon">check_circle</span>
          <span class="text">Create New</span>
          <span [ngClass]="{'hidden': true, 'shown': false }" class="material-symbols-outlined check-icon">check_circle</span>
        </div>
      </button>

    </div>

    <!-- CREATE (form) -->
    @if (isCreateFlow) {
    <form [formGroup]="createQuoteForm" class="margin-topped">
      <mat-form-field appearance="outline">
        <mat-label>Quote Name</mat-label>
        <input matInput formControlName="quoteName" />
      </mat-form-field>
    </form>
    }
    <!-- UPDATE (form) -->
    @else if(isUpdateFlow) {
    <form [formGroup]="saveQuoteForm" class="margin-topped">
      <mat-form-field appearance="outline">
        <mat-label>Quote Name</mat-label>
        <input matInput formControlName="quoteName" />
      </mat-form-field>
    </form>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div>
    @if (!isLoading) {
    @if (isCreateFlow) {
    <button mat-raised-button color="primary" type="button" (click)="doSave(createQuoteForm)" [disabled]="!createQuoteForm.valid">Save Quote</button>
    }
    @else if (isUpdateFlow) {
    <button mat-raised-button color="primary" type="button" (click)="doSave(saveQuoteForm)">Save Quote</button>
    }
    } @else {
    <mat-spinner [diameter]="25"></mat-spinner>
    }
  </div>
</mat-dialog-actions>
}
